import { render, staticRenderFns } from "./EditLog.vue?vue&type=template&id=2442e18c&"
import script from "./EditLog.vue?vue&type=script&lang=js&"
export * from "./EditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports